
export default {
  name: 'SubHeader',
  props: {
    socialData: {
      type: Object,
      required: true,
    },
  },
}
